
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'react-phone-number-input/style.css';
import './index.css';
import './i18n';
import App from './App';
import { initAmplitude } from './utils/amplitude';

initAmplitude();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
